module.exports = {
	"1.8": "59",
	"1.6": "56",
	"1.7": "58",
	"1.3": "52",
	"1.4": "53",
	"1.5": "54",
	"1.2": "51",
	"1.1": "50",
	"1.0": "49",
	"0.37": "49",
	"0.36": "47",
	"0.35": "45",
	"0.34": "45",
	"0.33": "45",
	"0.32": "45",
	"0.31": "44",
	"0.30": "44",
	"0.29": "43",
	"0.28": "43",
	"0.27": "42",
	"0.26": "42",
	"0.25": "42",
	"0.24": "41",
	"0.23": "41",
	"0.22": "41",
	"0.21": "40",
	"0.20": "39"
};


//////////////////
// WEBPACK FOOTER
// ./~/electron-to-chromium/versions.js
// module id = 2626
// module chunks = 0